/**
 * The new-build banner (`new-build.ts`): a deploy has gone out since
 * this page loaded. Small and in the flow of the shell, never over
 * anything, and it waits: only the Reload button reloads, because an
 * operator may be half way through an edit when it appears.
 */
import { useSyncExternalStore } from 'react';
import { AlertBanner } from '../design-system/components/AlertBanner';
import { isNewBuildReady, subscribeNewBuild } from './new-build';
import './NewBuildBanner.css';

export function NewBuildBanner({ onReload }: { onReload?: () => void } = {}) {
  const ready = useSyncExternalStore(subscribeNewBuild, isNewBuildReady, () => false);
  if (!ready) return null;
  return (
    <div className="nx-new-build">
      <AlertBanner
        variant="info"
        role="status"
        title="New version"
        testId="new-build-banner"
        actions={
          <button
            type="button"
            className="nx-new-build__reload"
            onClick={onReload ?? (() => window.location.reload())}
            data-testid="new-build-reload"
          >
            Reload
          </button>
        }
      >
        A new version of the console is ready.
      </AlertBanner>
    </div>
  );
}
